interface SortObject {
	sortType: string;
	sort: string;
}
const createSortObject = (value: string): SortObject => {
	const [sortType, sort] = value.split(':');

	return {
		sortType,
		sort: sort || 'desc',
	};
};

export const parseSort = (parameter: string) => {
	const defaultSort: SortObject = {
		sortType: 'date',
		sort: 'desc',
	};

	if (!parameter || parameter === '') {
		return defaultSort;
	}
	const sortParms = parameter.split('|');

	const reviewSortTypes: SortObject[] = sortParms.map((parm) => {
		const obj = createSortObject(parm);

		if (obj.sortType === 'createddate') {
			obj.sortType = 'date';
		}

		return obj;
	});

	const index = reviewSortTypes.findIndex(
		(sort) => sort.sortType === 'selectiontype',
	);

	if (index >= 0) {
		reviewSortTypes[index] = defaultSort;
	}

	if (reviewSortTypes.length === 0) {
		reviewSortTypes.push(defaultSort);
	}

	return reviewSortTypes[0];
};
